import React from 'react'
import { Link } from 'react-router-dom'

const Projects = () => {
  return (
    <div>

<div className="firstmain">
          <h1 className="projects">Project</h1>
          <div className="project">
            <h2>Real Time Chat App | April 2022 | <a href="https://chatapp0307.netlify.app/" target="_blank">Link</a> </h2>
            <p>
              ● In this project, I developed a backend server using NodeJS and
              ExpressJS, which handled user authentication and real-time
              communication using Socket.io.
            </p>
            <p>
              {" "}
              ● On the frontend, I used ReactJS and CSS to provide an intuitive
              and interactive user interface for the chat app.{" "}
            </p>
          </div>
          <div className="project">
            <h2>Netflix Clone | Jan 2023 | <a href="https://netflixclone0307.netlify.app/" target="_blank">Link</a></h2>
            <p>
              ● Throughout the project, I demonstrated a strong understanding of
              React JS concepts, such as component-based architecture and state
              management. I also showed proficiency in CSS, using responsive
              design techniques to ensure the Netflix clone looked and worked
              well across a range of devices.
            </p>
            <p>
              {" "}
              ● Additionally, I utilized the TMDb API to retrieve data about
              movies and TV shows, displaying this information in an intuitive
              and user-friendly manner.
            </p>
          </div>
          <div className="project">
            <h2>Portfolio | March 2022 |<a href="/" target="_blank">Link</a></h2>
            <p>
              ● In this project, I utilized my skills in HTML/CSS to create the
              basic structure and styling of the portfolio website.{" "}
            </p>
            <p>
              {" "}
              ● Additionally, I used React JS to add interactive components to
              the website, such as a navigation menu and a contact form.
            </p>
            <p>
              ● I also integrated Email.js to enable users to send me messages
              directly from the website.
            </p>
          </div>
          <div className="project">
            <h2>Portfolio | March 2022 |<a href="/" target="_blank">Link</a></h2>
            <p>
              ● In this project, I utilized my skills in HTML/CSS to create the
              basic structure and styling of the portfolio website.{" "}
            </p>
            <p>
              {" "}
              ● Additionally, I used React JS to add interactive components to
              the website, such as a navigation menu and a contact form.
            </p>
            <p>
              ● I also integrated Email.js to enable users to send me messages
              directly from the website.
            </p>
          </div>
          <div className="project">
            <h2>Portfolio | March 2022 |<a href="/" target="_blank">Link</a></h2>
            <p>
              ● In this project, I utilized my skills in HTML/CSS to create the
              basic structure and styling of the portfolio website.{" "}
            </p>
            <p>
              {" "}
              ● Additionally, I used React JS to add interactive components to
              the website, such as a navigation menu and a contact form.
            </p>
            <p>
              ● I also integrated Email.js to enable users to send me messages
              directly from the website.
            </p>
          </div>
          <div className="project">
            <h2>Portfolio | March 2022 |<a href="/" target="_blank">Link</a></h2>
            <p>
              ● In this project, I utilized my skills in HTML/CSS to create the
              basic structure and styling of the portfolio website.{" "}
            </p>
            <p>
              {" "}
              ● Additionally, I used React JS to add interactive components to
              the website, such as a navigation menu and a contact form.
            </p>
            <p>
              ● I also integrated Email.js to enable users to send me messages
              directly from the website.
            </p>
          </div>

          <h1 className="projects">Return to Website... | <Link to='/'>Link</Link></h1> 
        </div>
      
    </div>
  )
}

export default Projects